// A logger that does nothing, can be used in future test environments but mostly to be used when we try to init a prod logger and fail
import { ILogger } from './interface';

export class NoOpLogger implements ILogger {
  info(message: string) {}
  warn(message: string, error?: Error, stackTrace?: string) {}
  error(message: string, error: Error, stackTrace?: string) {}
  debug(message: string) {}
}
